
import http from "../../../../axios";

class RouteService {

  getTranslation() {
    return http().get(`/translations/get/en`);
  }

  getUserDetails() {
    return http().post(`/auth/sso/data`, {});
  }

}
export default new RouteService();